import { Component, OnInit, inject } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { PrimeNG } from 'primeng/config';
import {
  AuthService,
  InsurerConfigService,
  LayoutService,
  MemberService,
  MenuDataService,
} from 'shared';
import { RouterOutlet } from '@angular/router';
import { flatMap, mergeMap } from 'rxjs';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    imports: [RouterOutlet]
})
export class AppComponent implements OnInit {
  private PrimeNG = inject(PrimeNG);
  private menuDataService = inject(MenuDataService);
  private memberService = inject(MemberService);
  private layoutService = inject(LayoutService);
  private insurerConfigService = inject(InsurerConfigService);
  private titleService = inject(Title);
  private authService = inject(AuthService);

  model: any = [
    {
      label: '',
      icon: 'pi pi-fw pi-sitemap',
      items: [
        // {
        // label: 'Πίνακας Ελέγχου',
        // icon: 'pi pi-fw pi-home',
        // items: [
        {
          label: 'Γενική Επισκόπηση​​',
          icon: 'pi pi-fw pi-eye',
          routerLink: [''],
        },

        // {
        //   label: 'Συγκρίσεις Παρόχων',
        //   icon: 'pi pi-fw pi-book',
        //   routerLink: ['/secondgrade'],
        // },
        // ],
        // },
        {
          label: 'Ασφαλισμένοι​',
          icon: 'pi pi-fw pi-users',
          routerLink: ['/clients'],
        },
        // {
        //   label: 'Ασφαλιστήρια Συμβόλαια',
        //   icon: 'pi pi-fw pi-file',
        //   routerLink: ['/contracts'],
        // },
        {
          label: 'Ασφαλιστικά Προϊόντα​',
          icon: 'pi pi-fw pi-box',
          routerLink: ['/insurance_products'],
        },
        {
          label: 'Ασφαλιστικές Απαιτήσεις',
          icon: 'pi pi-fw pi-list',
          routerLink: ['/insurance_claims'],
        },
        {
          label: 'Συνεργαζόμενο Δίκτυο',
          icon: 'pi pi-fw pi-sitemap',
          items: [
            {
              label: 'Ιατρικό Προσωπικό​​​',
              icon: 'pi pi-fw pi-user-plus',
              routerLink: ['/affiliate_network/doctors'],
            },
            {
              label: 'Διαγνωστικά Κέντρα​',
              icon: 'pi pi-fw pi-search',
              routerLink: ['/affiliate_network/diagnostic-centers'],
            },
            {
              label: 'Νοσοκομεία​',
              icon: 'pi pi-fw pi-building',
              routerLink: ['/affiliate_network/hospitals'],
            },
          ],
        },
        {
          label: 'Συμβάσεις​',
          icon: 'pi pi-fw pi-file',
        },
        {
          label: 'Τιμοκατάλογοι',
          icon: 'pi pi-tags',
        },
        {
          label: 'Αναφορές',
          icon: 'pi pi-fw pi-chart-bar',
          routerLink: ['/reports'],
        },
        // {
        //   label: 'Λίστα εκκρεμοτήτων',
        //   icon: 'pi pi-fw pi-list',
        // },
      ],
    },
  ];

  ngOnInit(): void {
    this.PrimeNG.ripple.set(true);
    this.menuDataService.update(this.model);
    this.memberService.appName = 'insurers';
    const token = JSON.parse(localStorage.getItem('token')!);
    let user = undefined;
    if (token) {
      this.memberService
        .getEntityByUsername(token.token)
        .pipe(
          mergeMap((user: any) => {
            user = user;
            this.insurerConfigService.setInsurerConfig(user);
            return this.authService.fetchUser(token);
          })
        )
        .subscribe(() => {});
    }
  }
}
